/**
 * Lokales `yyyy-mm-dd`-Datums-Marshalling für persistierte Filter (URL + localStorage).
 *
 * Bewusst lokal gerechnet (kein UTC-Shift) — die Client-Filter rechnen lokal. Aus den
 * privaten Kopien im TX-Filter-Hook (Issue #300) gehoben, damit Subscriptions (Snapshot,
 * Spec 380 §4.2) und der TX-Hook eine gemeinsame Quelle teilen.
 */
export function formatDateParam(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function parseDateParam(value: string | null | undefined): Date | undefined {
  // Laufzeit-robust: ein korrupter persistierter Snapshot kann hier statt eines Strings
  // z. B. eine Zahl liefern — niemals `.split` darauf aufrufen (würde werfen).
  if (typeof value !== 'string') return undefined;
  const parts = value.split('-').map(Number);
  if (parts.length !== 3 || parts.some((n) => Number.isNaN(n))) return undefined;
  const [y, m, d] = parts;
  const date = new Date(y, m - 1, d);
  if (Number.isNaN(date.getTime())) return undefined;
  // Kalender-Overflow verwerfen statt still zu normalisieren (2026-02-31 → 03-03,
  // 2026-13-01 → 2027): ein unmögliches Datum ist „kaputt" und fällt weg.
  if (date.getFullYear() !== y || date.getMonth() !== m - 1 || date.getDate() !== d) {
    return undefined;
  }
  return date;
}
